export default __webpack_public_path__ + "static/media/Daco_434937.3c0adee3.png";